<template>
  <div v-loading="pageLoading">
    <div>
      <el-form :model="form"
               :label-width="formLabelWidth"
               style="margin: auto; width: 1000px"
               ref="form"
               >
        <el-form-item label="職員編號"
            prop="workNo"
           :rules="[
               { required: true, message: '賬號不能为空' },
            ]"
        >
          <el-input v-model="form.workNo"
                    placeholder="請輸入職員編號"
                    autocomplete="off"
                    style="width: 80%"></el-input>
        </el-form-item>
        <el-form-item label="名字">
          <el-input v-model="form.name"
                    placeholder="請輸入名字"
                    autocomplete="off"
                    style="width: 80%"></el-input>
        </el-form-item>
        <el-form-item label="賬號">請在APP/後台用戶管理處設置</el-form-item>
        <el-form-item label="密碼">請在APP/後台用戶管理處設置</el-form-item>
        <el-form-item label="性別">
          <el-select v-model="form.gender"
                     placeholder="請選擇性別"
                     style="width: 80%">
            <el-option label="M"
                       value="M"></el-option>
            <el-option label="F"
                       value="F"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分公司">
          <el-select v-model="form.manRegionId"
                     filterable
                     reserve-keyword
                     placeholder="請選擇分公司"
                     style="width: 80%;"
                     @change="selectRegion">
            <el-option v-for="item in region"
                       :key="item.id"
                       :label="item.regionName"
                       :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="部門/物業">
          <el-select v-model="form.manBranchId"
                     filterable
                     reserve-keyword
                     placeholder="請先選擇分公司"
                     style="width: 80%;"
                     @change="selectBranch">
            <el-option v-for="item in filiale"
                       :key="item.id"
                       :label="item.branchName"
                       :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用戶組別">
          <el-select v-model="form.manDepartmentId"
                     filterable
                     reserve-keyword
                     placeholder="請先選擇部門/物業"
                     style="width: 80%;">
            <el-option v-for="item in department"
                       :key="item.id"
                       :label="item.departmentName"
                       :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="職位">
          <el-select v-model="form.manPositionId"
                     filterable
                     placeholder="請先選擇部門/物業"
                     style="width: 80%;">
            <el-option v-for="item in position"
                       :key="item.id"
                       :label="item.positionName"
                       :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="入職日期">
          <el-date-picker type="date"
                          v-model="form.entryDate"
                          placeholder="选择时间"
                          value-format="yyyy-MM-dd"
                          style="width: 336px"></el-date-picker>
        </el-form-item>
        <el-form-item label="聯繫方式">
          <el-input v-model="form.contactWay"
                    placeholder="請輸入手機號"
                    autocomplete="off"
                    style="width: 80%"></el-input>
        </el-form-item>
        <el-form-item label="離職日期">
          <el-date-picker type="date"
                          v-model="form.dimissionDate"
                          placeholder="选择时间"
                          value-format="yyyy-MM-dd"
                          style="width: 336px"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <!-- 佔位 -->
        </el-form-item>
        <el-form-item label="英文名">
          <el-input v-model="form.address"
                    placeholder="請輸入英文名"
                    autocomplete="off"
                    style="width: 180%"></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button @click="$router.back(-1)">取 消</el-button>
        <el-button type="primary"
                   @click="addUser">確 定</el-button>
      </div>
      <el-button class="back"
                 @click="$router.back(-1)">返 回</el-button>
    </div>
  </div>
</template>

<script>
var that;
export default {
  data () {
    return {
      pageLoading: false,

      form: {
        workNo: "",
        name: "",
        manRegionId: "",
        manBranchId: "",
        manDepartmentId: "",
        manPositionId: "",
        entryDate: "",
        contactWay: "",
        dimissionDate: "",
        address: "",
        gender: "",
      },
      formLabelWidth: "80px",
      region: [],
      filiale: [],
      department: [],
      position: [],
      id: "",
      manRegionIdTemp: "",

      loading: undefined,
    };
  },
  mounted () {
    that.id = sessionStorage.getItem("userId");
    $("#pageHead").text("編輯用戶");
    // 获取数据
    this.pageLoading = true
    this.$store.dispatch('commonData/getEchoDistrictBranchDepartmentList').then(() => {
      this.region = this.$store.state.commonData.echoDistrictBranchDepartmentList
      this.getMsg()
    })
  },
  methods: {
    getMsg () {
      this.axios({
        url: "/manage/getComUser",
        params: {
          id: that.id,
        },
      })
        .then((res) => {
          var msg = res.result[0],
          form = that.form;
          form.name = msg.name;
          form.manRegionId = msg.manRegionId;
          form.entryDate = msg.entryDate;
          form.contactWay = msg.contactWay;
          console.log(msg.contactWay);
          form.address = msg.address;
          form.gender = msg.gender;
          that.manRegionIdTemp = msg.manRegionId;
          that.selectRegion(msg.manRegionId);
          form.manBranchId = msg.manBranchId;
          that.selectBranch(msg.manBranchId);
          form.manDepartmentId = msg.manDepartmentId;
          // that.selectDep(msg.manDepartmentId);
          form.manPositionId = msg.manPositionId;
          form.dimissionDate =msg.dimissionDate;

          var accountIF = /^[0-9]+$/.test(msg.workNo);
          console.log("*****************************"+accountIF);
          if(accountIF){
            form.workNo = parseInt(msg.workNo);
          }else{
            form.workNo = msg.workNo;
          }




          this.pageLoading = false
        })
        .catch(e => {
          console.log(e);
          this.pageLoading = false
        });
    },
    addUser () {
      var form = that.form;
      
      for (let item in form) {
          if (form[item] == ""&& !form.dimissionDate) {
            this.$message({
              type: "warning",
              message: "請將數據填寫完整!",
            });
            return;
          }
        }

      // if (!(/^[0-9]*$/.test(form.workNo))) {
      //   this.$message({
      //     type: 'warning',
      //     message: '職員編號只能使用數字'
      //   })
      //   return
      // }

      if (!form.contactWay) {
        this.$message({
          type: "warning",
          message: "請填寫手機號!",
        });
        return;
      }

      form["id"] = that.id;
      this.pageLoading = true
      this.axios({
        url: "/manage/updateComUser",
        method: "post",
        params: form,
      })
        .then(res => {
          if (res.code==200) {
            that.$message({
              message: res.message,
              showClose: true,
              type: "success",
            });
            setTimeout(function () {
              that.$router.go(-1);
            }, 1000);
          }else{
            that.$message({
              showClose: true,
              type: "warning",
              message:"请联系管理员"
            });
            this.pageLoading = false
          }
        })
        .catch(() => {
          this.pageLoading = false
        });
    },
    selectRegion (val) {
      // 已選擇地區
      var reg = this.region;
      for (let i = 0; i < reg.length; i++) {
        if (reg[i].id == val) {
          this.form.manBranchId = null
          this.form.manDepartmentId = null
          this.form.manPositionId = null
          this.filiale = reg[i].branchList
          this.department = [];
          this.position = [];
          break;
        }
      }
    },
    selectBranch (val) {
      // 已選分公司
      var fil = that.filiale;
      for (let i = 0; i < fil.length; i++) {
        if (fil[i].id == val) {
          that.form.manDepartmentId = '';
          that.form.manPositionId = '';
          that.department = fil[i].departmentList;
          that.position = fil[i].positionList;

          // this.position = [];
          break;
        }
      }
    },
    // selectDep (val) {
    //   // 已選分部門
    //   var dep = that.department;
    //   for (let i = 0; i < dep.length; i++) {
    //     if (dep[i].id == val) {
    //       that.form.manPositionId = '',
    //         that.position = dep[i].positionList;
    //       break;
    //     }
    //   }
    // }
  },
  created () {
    that = this;
    this.id = sessionStorage.getItem("userId");
    // this.getMsg();
  },
};
</script>

<style scoped>
.btn {
  margin-left: 20px;
}

.dialog-footer {
  display: flex;
  justify-content: space-around;
  width: 400px;
  margin: auto;
}

.el-form-item {
  width: 500px;
  display: inline-block;
}
.back {
  position: absolute;
  top: 90px;
  right: 45px;
}
</style>
